import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';

export default graphql(
  gql`
    mutation UpdateTrack($input: UpdateTrackInput!) {
      updateTrack(input: $input) {
        id
        image
        logo
        image_id
        twitter_image_id
        facebook_image_id
        facebook_image
        twitter_image
        logo_id
        name
        short_name
        street
        state
        city
        zipcode
        phone
        website
        schedule
        added_by
        type {
          id
          key
          value
        }

        size
        bio
        twitter
        facebook
        instagram
        youtube
        tiktok
        poc {
          id
        }
        user_id
        faqs {
          id
          question
          answer
        }
        status
        active
        timezone
        fullAddress
        chart_id
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      updateTrack: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
          })
        );
      },
    }),
  }
);
